// Static registry of Cerveza import templates per country.
// Kept in code (not DB) because template version + publication gate live in
// the Excel audit workbooks under /mnt/documents/cerveza-imports/, not Supabase.
// Update this table whenever a new V1/V2 workbook is produced or the gate flips.

export type PublicationGate = "PASS" | "PARTIAL" | "PENDING" | "NOT_STARTED";

export type CountryTemplateInfo = {
  template_version: "V1" | "V2" | null;
  gate: PublicationGate;
  notes?: string;
};

// ISO-2 keyed. Absence => NOT_STARTED / no template.
export const COUNTRY_TEMPLATES: Record<string, CountryTemplateInfo> = {
  CZ: { template_version: "V2", gate: "PASS" },
  SK: { template_version: "V2", gate: "PASS" },
  DE: { template_version: "V2", gate: "PASS" },
  AT: { template_version: "V2", gate: "PASS" },
  PL: { template_version: "V2", gate: "PASS" },
  BE: { template_version: "V2", gate: "PASS" },
  NL: { template_version: "V2", gate: "PASS" },
  IE: { template_version: "V1", gate: "PARTIAL", notes: "3 majors (Diageo/Heineken/Molson Coors) + 14 craft, 17 sites s GPS; V2 doplní SKU/EAN a licensing" },
  GB: { template_version: "V2", gate: "PASS" },
  FR: { template_version: "V2", gate: "PARTIAL", notes: "Coverage Repair Batch 01 + 02 zaimportovány: 421 breweries + sites, 379 měst, 43 admin_areas (Grand Est, Hauts-de-France, dep. discovery). Batch 02 = 288 kandidátů (DO_NOT_PUBLISH) čekajících na ověření." },
  KZ: { template_version: "V1", gate: "PARTIAL", notes: "Asia Dependencies Batch 19: 5 operátorů (Efes/Carlsberg/Shymkentbeer/Perviy/Caspian), 7 sites, 30 brands, 37 produktů, 20 admin_areas + 27 měst" },
  ES: { template_version: "V2", gate: "PARTIAL" },
  IT: { template_version: "V2", gate: "PARTIAL" },
  PT: { template_version: "V2", gate: "PARTIAL", notes: "APCV zdroj neověřen, EAN capture čeká" },
  CH: { template_version: "V1", gate: "PASS" },
  DK: { template_version: "V1", gate: "PARTIAL", notes: "Carlsberg/Tuborg + Royal Unibrew + 12 craft, 15 sites s GPS" },
  SE: { template_version: "V1", gate: "PARTIAL", notes: "Spendrups/Kopparbergs/Carlsberg SE + 13 craft, 16 sites s GPS" },
  NO: { template_version: "V1", gate: "PARTIAL", notes: "Ringnes/Hansa Borg/Mack/Aass + 11 craft, 15 sites s GPS" },
  FI: { template_version: "V1", gate: "PARTIAL", notes: "Sinebrychoff/Hartwall/Olvi + 11 craft, 14 sites s GPS" },
  RO: { template_version: "V1", gate: "PENDING", notes: "Craft rozšíření a licensing → V2" },
  BG: { template_version: "V1", gate: "PENDING", notes: "Craft rozšíření a licensing → V2" },
  HU: { template_version: "V1", gate: "PENDING" },
  SI: { template_version: "V1", gate: "PENDING" },
  HR: { template_version: "V1", gate: "PENDING" },
  GR: { template_version: "V1", gate: "PENDING" },
  IQ: { template_version: "V1", gate: "PARTIAL", notes: "4 sites (Al-Omran, Farida, Sinalco, Karwanchi) s GPS; kandidáti KRG/Aujan blokováni" },
  IL: { template_version: "V1", gate: "PARTIAL", notes: "Tempo + Carlsberg Israel + 4 craft, 6 sites s GPS" },
  JP: { template_version: "V1", gate: "PARTIAL", notes: "Asahi/Kirin/Sapporo/Suntory/Orion + YOHO, 6 sites s GPS; YOHO Osaka blokován" },
  JO: { template_version: "V1", gate: "PARTIAL", notes: "GIC Zarqa + Carakale + Mutamayizah, 3 sites s GPS; Moussy kandidát blokován" },
};

export function getTemplateInfo(iso2: string): CountryTemplateInfo {
  return (
    COUNTRY_TEMPLATES[iso2.toUpperCase()] ?? {
      template_version: null,
      gate: "NOT_STARTED",
    }
  );
}
